/* eslint-disable eqeqeq */
/* eslint-disable id-length */
/* eslint-disable sort-keys */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import { useState, useEffect } from 'react'
import moment from 'moment'
import { getPedidos } from '../api/pedidos.servico'
import { useGlobal } from '../contexts/GlobalContext'

export default function useEnvioUnico( pedidos ) {
  const { dadosGlobaisAssociado } = useGlobal()
  const [ isEnvioUnico, setIsEnvioUnico ] = useState( null )
  const [ loading, setLoading ] = useState( false )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      verifyIfHasEnvioUnico()
    }
  }, [ dadosGlobaisAssociado, pedidos ] )

  async function verifyIfHasEnvioUnico() {
    setLoading( true )
    let dataPedidos
    if ( pedidos ) {
      dataPedidos = pedidos
    } else {
      const response = await getPedidos()
      dataPedidos = response.data
    }
    const mesTagAtual =
        dadosGlobaisAssociado?.modalidades[ 0 ]?.mesTagAtual?.id
    const momentMesTagAtual = moment( mesTagAtual, 'M/YYYY' ).format( 'MMMM' )
    const momentAnoTagAtual = moment( mesTagAtual, 'M/YYYY' ).format( 'YYYY' )


    const pedido = dataPedidos.find( p => p?.mesTag.toLowerCase() === momentMesTagAtual &&
        p?.anoTag == momentAnoTagAtual )
    if ( pedido ) {
      setIsEnvioUnico( pedido.pedidoIsCombo )
    }
    setLoading( false )
  }

  return [ isEnvioUnico, loading ]
}
